import { render } from "./VesCalendarIndicator.vue?vue&type=template&id=387cca75&scoped=true"
import script from "./VesCalendarIndicator.vue?vue&type=script&lang=js"
export * from "./VesCalendarIndicator.vue?vue&type=script&lang=js"

import "./VesCalendarIndicator.vue?vue&type=style&index=0&id=387cca75&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-387cca75"]])

export default __exports__